/* Generated by scripts/apply-brand.js — do not edit by hand */
/** Every brand folder under brands/. */
export const BRAND_IDS = ["gpqbank","ogqbank","ophthalmologyq","solicitorqs"] as const;
export type BrandId = (typeof BRAND_IDS)[number];

/** CRA inlines this at build time; falls back to brand.marketingUrl when unset. */
export const marketingUrlFromEnv: string | undefined = process.env.REACT_APP_MARKETING_URL_OGQBANK;

export const brand = {
  id: "ogqbank",
  displayName: "OGQBank",
  appUrl: "https://app.ogqbank.com",
  marketingUrl: "https://ogqbank.com",
  contactEmail: "ogqbank@gmail.com",
  metaDescription: "MRCOG Part 1, MRCOG Part 2 and DRCOG question banks: exam-style questions, clear explanations, analytics and timed practice.",
  footerDescriptionHtml: "<strong>MRCOG and DRCOG question banks</strong> for doctors in obstetrics and gynaecology: exam-style questions, clear explanations and timed practice.",
  signupKeyFeatures: ["Exam-style MRCOG Part 1, MRCOG Part 2 and DRCOG questions","Clear explanations for every answer","Analytics to target weak areas of the syllabus","Timed practice under exam conditions"],
  s3Bucket: "app.ogqbank.com",
  productIds: ["mrcog_part_1","mrcog_part_2","drcog"],
  colors: {
    primary: "#8c1d5a",
    primaryHover: "#6a1644",
    navy: "#3f0d29",
    navyDeep: "#2a091b",
    navyMid: "#591239",
    accent: "#9d2165",
    accentAlt: "#ae2470",
    stats: "#8c1d5a",
    statsHover: "#591239",
    footer: "#3f0d29",
    footerDeep: "#2a091b",
    footerLight: "#591239",
    footerMuted: "#190510",
  },
} as const;

export type Brand = typeof brand;
